import { Component, OnInit } from '@angular/core';

import { User, UserService, UsersStore } from '@fry/lib/users';
import { FormData, FormProviderService } from '@fry/lib/forms';
import { MatDialog } from '@angular/material/dialog';
import { FormDialogComponent } from '@fry/components/common/form';
import { catchError, map } from 'rxjs/operators';
import { NotifyService } from '@fry/lib/utils';
import { Validators } from '@angular/forms';

@Component({
    selector: 'app-user-edit-emails',
    templateUrl: './user-edit-emails.component.html',
    standalone: false
})
export class UserEditEmailsComponent implements OnInit {

  public user: User;
  public emails: any[];
  public form: FormData;

  private _fields = [
    { id: 'email', title: $localize `Email`, initial: '',
      widget: { type: 'string', autocomplete: '' },
      validators: [Validators.required] }
  ];

  constructor(
    private userService: UserService,
    private users: UsersStore,
    private provider: FormProviderService,
    private dialog: MatDialog,
    private notify: NotifyService
  ) { }


  ngOnInit() {
    this.user = this.userService.user;
    this.emails = this.user.emails;
  }

  public onClick(idx: number) {
    const email = this.emails[idx];
    console.log(email, idx);
    this.provider.getFormDataWith(this._fields, email).subscribe(
      form => {
        const dialogRef = this.dialog.open(FormDialogComponent, {
          data: {
            title: $localize `Edit email`,
            form,
            onSubmit: (value) => {
              this.emails[idx].email = value.email;
              return this.saveEmails();
            }
          }
        });

      dialogRef.afterClosed().subscribe(() => {
        console.log('The dialog was closed');
      });

    });
  }

  public onRemove(idx: number) {
    const email = this.emails[idx];
    if (email.type === 'primary') {
      this.notify.error('It is not possible to remove a primary email');
      return undefined;
    }

    this.emails.splice(idx, 1);
    return this.saveEmails().subscribe();
  }

  private saveEmails() {
    return this.users.updateEmails(this.user, this.emailData).pipe(
      map(data => {
        this.user = data;
        this.emails = data.emails;
        this.userService.setUser(data);
        this.notify.success('Profile successfully saved');
      }),
      catchError(error => {
        this.emails = this.user.emails;
        this.notify.error(error);
        throw error;
        // return throwError(error);
      })
    );
  }

  private get emailData() {
    const primary = this.emails.filter(item => item.type === 'primary');
    const secondary = this.emails.filter(item => item.type === 'secondary');
    return {
      email: primary.length > 0 ? primary[0].email : '',
      secondaryEmails: secondary.map(item => item.email),
    };
  }
}
